import '../../css/base.css';

const Pets = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Pets</h2>
      <p className="your-stay-text">Well behaved dogs are very welcome at Shore Cottage. Please note that
                                    they are not allowed upstairs, on furniture or beds. Please wipe muddy,
                                    wet paws in the boot room.
                                    There are sheep, highland cattle and deer around and about and so your
                                    dogs <strong>must</strong> be kept under control at all times in the village. 
      </p>                                            
    </div>
  );
}

export default Pets;